export default "__VITE_ASSET__355514e2__"